export const isUndefined = (value) => typeof value === 'undefined';
export const isNotUndefined = (value) => typeof value !== 'undefined';
export const isBoolean = (value) => typeof value === 'boolean';
export const isNotBoolean = (value) => typeof value !== 'boolean';
export const isNumber = (value) => typeof value === 'number';
export const isNotNumber = (value) => typeof value !== 'number';
export const isString = (value) => typeof value === 'string';
export const isNotString = (value) => typeof value !== 'string';
export const isSymbol = (value) => typeof value === 'symbol';
export const isNotSymbol = (value) => typeof value !== 'symbol';
export const isNull = (value) => value === null;
export const isNotNull = (value) => value !== null;
